module.exports = __webpack_public_path__ + "img/China-4.c5e6dbcc.jpg";